import DashboardLayout from '@/views/Layout/DashboardLayout.vue';

// Visits
const VisitsList = () => import(/* webpackChunkName: "visits" */ '@/views/Visits/List.vue');
const VisitCreate = () => import(/* webpackChunkName: "visits" */ '@/views/Visits/Create.vue');
const VisitShow = () => import(/* webpackChunkName: "visits" */ '@/views/Visits/Show.vue');

let visitsPages = {
  path: '/visits',
  redirect: '/visits',
  component: DashboardLayout,
  name: 'Visits',
  meta: {
    title: 'Visitas',
    auth: true,
  },
  children: [
    {
      path: '',
      name: 'VisitsList',
      meta: {
        title: 'Listado',
        auth: ['visits.index'],
      },
      component: VisitsList,
    },
    {
      path: 'create',
      name: 'VisitCreate',
      meta: {
        title: 'Nueva',
        auth: ['visits.store'],
      },
      component: VisitCreate,
    },
    {
      path: ':id',
      name: 'VisitShow',
      meta: {
        title: 'Detalle',
        auth: ['visits.show'],
      },
      component: VisitShow,
    },
  ],
};

export default visitsPages;
